import { Icon } from '@examdojo/core/icon';
import { BaseContentBlock, ContentBlockType } from './base-block.model';
import type { ContentBlock } from './block.model';

export enum CalloutColor {
  Teal = 'teal',
  Indigo = 'indigo',
  Yellow = 'yellow',
  Red = 'red',
  Gray = 'gray',
}

export interface CalloutBlock extends BaseContentBlock<ContentBlockType.Callout> {
  title: string;
  color: CalloutColor;
  icon?: Icon;
  content: ContentBlock[];
}
